var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("I grafen ser du hur många personer som varit inskrivna för sjukhusvård dag för dag. Uppgifterna finns från och med 25 mars.")]),_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }